import { CSSProperties } from 'react'

interface PortfolioConnectorLinesProps {
  isFirst?: boolean
  isLast?: boolean
  verticalLeftClassName?: string
  verticalTop?: string
  mobileVerticalTop?: string
  verticalBottom?: string
  mobileTop?: string
  mobileLeft?: string
  mobileWidth?: string
  desktopLeft?: string
  desktopWidth?: string
  color?: string
  zIndex?: number
  showMobile?: boolean
  showDesktop?: boolean
}

export function PortfolioConnectorLines({
  isFirst = false,
  isLast = false,
  verticalLeftClassName = 'left-3 sm:left-6',
  verticalTop,
  mobileVerticalTop,
  verticalBottom,
  mobileTop = 'calc(0.5rem + 1rem)',
  mobileLeft = 'calc(0.75rem + 1px)',
  mobileWidth = '8px',
  desktopLeft = 'calc(1.5rem + 1px)',
  desktopWidth = '8px',
  color = '#394E6A',
  zIndex,
  showMobile = true,
  showDesktop = true,
}: PortfolioConnectorLinesProps) {
  const sharedStyle: CSSProperties = {
    backgroundColor: color,
    ...(zIndex !== undefined ? { zIndex } : {}),
  }

  return (
    <>
      {showMobile && (
        <div
          className={`sm:hidden absolute w-px ${verticalLeftClassName}`}
          style={{
            ...sharedStyle,
            top: mobileVerticalTop ?? verticalTop ?? (isFirst ? '8px' : '0'),
            bottom: verticalBottom ?? (isLast ? '8px' : '0'),
          }}
        />
      )}

      {showDesktop && (
        <div
          className={`hidden sm:block absolute w-px ${verticalLeftClassName}`}
          style={{
            ...sharedStyle,
            top: verticalTop ?? (isFirst ? '8px' : '0'),
            bottom: verticalBottom ?? (isLast ? '8px' : '0'),
          }}
        />
      )}

      {showMobile && (
        <div
          className="sm:hidden absolute h-px"
          style={{
            ...sharedStyle,
            left: mobileLeft,
            width: mobileWidth,
            top: mobileTop,
          }}
        />
      )}

      {showDesktop && (
        <div
          className="hidden sm:block absolute top-1/2 h-px"
          style={{
            ...sharedStyle,
            left: desktopLeft,
            width: desktopWidth,
          }}
        />
      )}
    </>
  )
}
